


































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";

@Component
export default class Terms extends Vue {
  public mounted() {
    document.title =
      "利用規約 | favsalon(ファブサロン) | 再来率を向上させるサロンに特化したネットショップサービス";
    const descriptonMeta = document.querySelector("meta[name='description']");
    if (descriptonMeta) {
      descriptonMeta.setAttribute(
        "content",
        "利用規約 | favsalon（ファブサロン）なら美容室やネイルサロン、リラクサロンなどのサロンメニューに特化したネットサロンを簡単に作ることができます。シークレットメニューで来店者のみに販売するサービスを作って再来率を向上させます！"
      );
    }
    const robotsMeta = document.querySelector("meta[name='robots']");
    if (robotsMeta) {
      robotsMeta.setAttribute("content", "index, follow");
    }
  }
}
